import { useReducer, useRef, useState } from "react";
import { useDetectOutsideClick } from "../utils/useDetectOutsideClick";

function useEmojiPopupHook({
    emojiRef,
    inputRef,
    scrollContainerRef,
    setChatText
}) {
    const [shouldBeTop, setShouldBeTop] = useState(false);
    const [showEmojiPopup, setShowEmojiPopup] = useDetectOutsideClick(emojiRef, false);
    const savedRangeRef = useRef(null);

    const handleShowEmojis = (e) => {
        e.preventDefault();

        if(!showEmojiPopup) {
            saveSelection();
        }

        inputRef.current.focus()

        restoreSelection();


        if(scrollContainerRef.current.scrollHeight > 300) {
            setShouldBeTop(true)
        }else {
            setShouldBeTop(false)
        }

        setShowEmojiPopup(prev => !prev);
    }

    const saveSelection = () => {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            savedRangeRef.current = selection.getRangeAt(0).cloneRange();
        }
    };

    const restoreSelection = () => {
        const selection = window.getSelection();
        if (savedRangeRef.current) {
            selection.removeAllRanges();
            selection.addRange(savedRangeRef.current);
        }
    };

    const onEmojiClick = (e, { emoji }) => {
        const sel = window.getSelection();
        inputRef.current?.focus(); 
        if (sel.getRangeAt && sel.rangeCount) {
            let range = sel.getRangeAt(0);
            range.deleteContents();

            // Create the emoji span
            const span = document.createElement("span");
            span.className = "emoji-span";
            span.contentEditable = "false"; // Make it non-editable
            span.textContent = e.emoji;

            // Insert it at the current cursor position
            range.insertNode(span);

            // Move cursor after the inserted emoji
            range = range.cloneRange();
            range.setStartAfter(span);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        }

        setChatText(inputRef.current?.innerHTML);

        setShowEmojiPopup(prev => !prev);
    };

    const customEmojiClassname = shouldBeTop ? 'at-the-top' : 'at-the-bottom';

    return {
        shouldBeTop,
        setShouldBeTop,
        showEmojiPopup,
        setShowEmojiPopup,
        handleShowEmojis,
        customEmojiClassname,
        onEmojiClick
    };
}

export default useEmojiPopupHook;